import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../css/DateInput.css';

const DateInput = ({
  value,
  onChange,
  name,
  className = '',
  disabled = false,
  onTouchStart,
  placeholder = 'Select date',
  ...props
}) => {
  // Convert string value to Date object for DatePicker
  const dateValue = value ? new Date(value) : null;

  const handleChange = (date) => {
    if (date) {
      // Format the date as YYYY-MM-DD to match the native input format
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;

      // Create a synthetic event to match the native input onChange signature
      const syntheticEvent = {
        target: {
          name: name,
          value: formattedDate
        }
      };
      onChange(syntheticEvent);
    }
  };

  return (
    <DatePicker
      selected={dateValue}
      onChange={handleChange}
      dateFormat="yyyy-MM-dd"
      className={`form-control small-font ${className}`}
      disabled={disabled}
      placeholderText={placeholder}
      showYearDropdown
      showMonthDropdown
      dropdownMode="select"
      autoComplete="off"
      {...props}
    />
  );
};

export default DateInput;
